import React from 'react';
import { View, Text } from 'react-native';
import { StyleSheet } from 'react-native-unistyles';
import { useRouter } from 'expo-router';
import EmptyListPlaceholder from '@/components/General/EmptyListPlaceholder';
import SolidButton from '@/components/General/SolidButton';
import AppBackground from './AppBackground';

/**
 * Shown in place of a route the current plan doesn't include (Free orgs).
 * Rendering this instead of redirecting keeps direct deep-links stable — no
 * redirect loop, URL stays put, and the blocked screen never mounts its
 * paid-module queries. Backend RLS/RPC remains the real enforcement; this is
 * only UX.
 */
const PlanRestrictedScreen = ({ title = "Not available on this plan", message = "This feature isn't included in the Free plan. An admin can upgrade from Settings → Organization → Billing." }) => {
    const router = useRouter();

    return (
        <AppBackground testID="plan-restricted-screen" style={styles.root}>
            <EmptyListPlaceholder icon="lock-closed-outline" message={title} spacing={40} />
            <Text style={styles.message}>{message}</Text>
            <View style={styles.actions}>
                <SolidButton
                    text="Back to People"
                    testID="plan-restricted-back-to-people"
                    onPress={() => router.replace('/(tabs)/(home)/people')}
                />
            </View>
        </AppBackground>
    );
};

const styles = StyleSheet.create(({ colors, fonts, spacing }) => ({
    root: {
        flex: 1,
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: colors.background,
        paddingHorizontal: spacing.lg,
    },
    message: {
        color: colors.textSecondary,
        fontFamily: fonts.body,
        fontSize: 14,
        textAlign: 'center',
        maxWidth: 420,
        marginTop: -60,
    },
    actions: {
        marginTop: spacing.lg,
    },
}));

export default PlanRestrictedScreen;
